import { render, staticRenderFns } from "./JobAging.vue?vue&type=template&id=36bd1dd2&"
import script from "./JobAging.vue?vue&type=script&lang=js&"
export * from "./JobAging.vue?vue&type=script&lang=js&"
import style0 from "./JobAging.vue?vue&type=style&index=0&id=36bd1dd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports